export default {
  storageOptions: {
    namespace: 'yjh__',
    name: 'ls',
    storage: 'local'
  }
}
